export default __webpack_public_path__ + "static/media/New_WheelArrow.2e91479b.png";